import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sf-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Choose an objective and then a game to earn Maths Points", -1)
const _hoisted_3 = {
  key: 0,
  class: "tw-grid tw-grid-cols-2 tw-mb-2"
}
const _hoisted_4 = { class: "tw-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DbMathLevelItem = _resolveComponent("DbMathLevelItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rootCategories, (cat) => {
      return (_openBlock(), _createElementBlock("div", {
        key: cat.id + '_' + _ctx.currentYear,
        class: "tw-mb-4 last:tw-mb-0"
      }, [
        _createElementVNode("ul", null, [
          _createVNode(_component_DbMathLevelItem, {
            category: cat,
            "all-categories": _ctx.allCategories,
            "all-levels": _ctx.allLevels,
            students: _ctx.students,
            "teacher-mode": _ctx.isTeacher,
            "current-user": _ctx.$currentUser.value,
            "default-year": _ctx.defaultYear,
            "show-year-paging": _ctx.showYearPaging
          }, null, 8, ["category", "all-categories", "all-levels", "students", "teacher-mode", "current-user", "default-year", "show-year-paging"])
        ])
      ]))
    }), 128)),
    (_ctx.isIndividual)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (_ctx.defaultYear > 1)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.offsetDefaultYear(-1)), ["prevent"])),
                  class: "primary"
                }, " < Previous Year "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.defaultYear < 6)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.offsetDefaultYear(1)), ["prevent"])),
                  class: "primary"
                }, " Next Year > "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}